import { configureStore } from '@reduxjs/toolkit';

import { environment } from '@paragon/environment-tools';
import { logInData } from '@paragon/login-tools';
import { spinnerMessages } from '@paragon/task-spinner';
import { theme } from '@paragon/themes';

import { comparisonResults } from './comparisonResultsSlice';
import { conversionResults } from './conversionResultsSlice';

export const store = configureStore({
  reducer: {
    logInData,
    spinnerMessages,
    environment,
    theme,
    conversionResults,
    comparisonResults,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
